const product = {
  product: "Produk", // translated 
  products: "Produk", // translated 
  information: "Maklumat", // translated 
  additionalInformation: "Maklumat Tambahan", // translated 
  contactUs: "Hubungi Kami", // translated 
  contactUsText: "Ingin menyesuaikan lawatan anda atau mempunyai sebarang soalan lain?", // translated 
  dropUsAnEmail: "Hantarkan emel kepada kami", // translated 
  viewLess: "Lihat kurang", // translated 
  viewMore: "Lihat lebih banyak lagi", // translated 
  less: "kurang", // translated 
  more: "lebih banyak", // translated 
  highlights: "Sorotan", // translated 
  inclusions: "Rangkuman", // translated 
  exclusions: "Pengecualian", // translated 
  pleaseWait: "Sila tunggu...", // translated 
  tourType: "Jenis Lawatan", // translated 
  search: "Carian", // translated 
  available: "Tersedia", // translated 
  availableTours: "Lawatan yang Tersedia", // translated 
  sortBy: "ISIHKAN MENGIKUT", // translated 
  priceLowToHigh: "Harga: Rendah ke Tinggi", // translated 
  priceHighToLow: "Harga: Tinggi ke Rendah", // translated 
  mostPopular: "Paling Popular", // translated 
  roomOnly: "Bilik Sahaja", // translated 
  bedAndBreakfast: "Penginapan & Sarapan", // translated 
  halfBoard: "Separuh Makan", // translated 
  fullBoard: "Makan Penuh", // translated 
  allInclusive: "Semua Termasuk", // translated 
  viewDetails: "Lihat Butiran", // translated 
  close: "Tutup", // translated 
  at: "Pada", // At dat, // translated 
  person: "orang", // translated 
  cancellationPolicy: "Polisi Pembatalan", // translated 
  cancellationIs: "pembatalan adalah", // translated 
  to: "Kepada", // translated 
  bookingRemarks: "Catatan Tempahan", // translated 
  totalPrice: "Jumlah Harga", // translated 
  back: "Kembali", // translated 
  bookNow: "Tempah Sekarang", // translated 
  minutes: "Minit", // translated 
  visitDuration: "Tempoh Lawatan", // translated 
  itinerary: "Jadual Perjalanan", // translated 
  airportToHotel: "Lapangan Terbang ke Hotel", // translated 
  hotelToAirport: "Hotel ke Lapangan Terbang", // translated 
  details: "butiran", // translated 
  servicesDetails: "Butiran Perkhidmatan", // translated 
  services: "Perkhidmatan", // translated 
  day: "Hari", // translated 
  next: "Seterusnya", // translated 
  nextStep: "Langkah Seterusnya", // translated 
  skip: "Langkau", // translated 
  remarks: "Catatan", // translated 
  optional: "pilihan", // translated 
  guests: "Tetamu", // translated 
  payment: "Pembayaran", // translated 
  pickup: "pengambilan", // translated 
  featuredPackage: "Pakej Pilihan", // translated 
  flights: "Penerbangan", // translated 
  accommodation: "Penginapan", // translated 
  transfers: "Pemindahan", // translated 
  tours: "Lawatan", // translated 
  experiences: "Pengalaman", // translated 
  featuredTour: "Lawatan Pilihan", // translated 
  From: "Dari", // translated 
  Accommodation: "Penginapan", // translated 
  approxDuration: "Anggaran tempoh", // translated 
  travellerInformation: "Maklumat Pengembara", // translated 
  bookingOverview: "Gambaran Keseluruhan Tempahan", // translated 
  checkout: "Daftar keluar", // translated 
  paymentFailed: "Pembayaran Gagal", // translated 
  paymentSuccess: "Kejayaan Pembayaran", // translated 
  night: "Malam", // translated 
  nights: "Malam-malam", // translated 
  viewEscapes: "Lihat Pelarian", // translated 
  viewExperience: "Lihat Pengalaman", // translated 
  escapeType: "Jenis Melarikan Diri", // translated 
  adultsOnly: "Dewasa Sahaja", // translated 
  totalDuration: "Jumlah Tempoh", // translated 
  options: "Pilihan", // translated 
  departingAirport: "Lapangan Terbang Berlepas", // translated 
  childrenAreNotAllowedInThisTour: "Kanak-kanak tidak dibenarkan dalam lawatan ini", // translated 
};








export default product;
